// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #074F71;
    padding: 12px 24px;
    color: white;
}

.header-title {
    font-weight: 600;
    color: white;
}

.header-toggle-group {
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 8px;
}

.header-toggle-button {
    color: rgba(255, 255, 255, 0.7) !important;
    border-color: rgba(255, 255, 255, 0.2) !important;
    padding: 6px 16px !important;
    text-transform: none !important;
}

.header-toggle-button.Mui-selected {
    color: white !important;
    background-color: rgba(255, 255, 255, 0.2) !important;
}

.header-toggle-button:hover {
    background-color: rgba(255, 255, 255, 0.1) !important;
}

.header-toggle-icon {
    margin-right: 6px;
    font-size: 20px;
}

.header-toggle-label {
    font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/components/header.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA;IACI,0CAA0C;IAC1C,iDAAiD;IACjD,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;IACvB,qDAAqD;AACzD;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".header-container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background-color: #074F71;\n    padding: 12px 24px;\n    color: white;\n}\n\n.header-title {\n    font-weight: 600;\n    color: white;\n}\n\n.header-toggle-group {\n    background-color: rgba(255, 255, 255, 0.1);\n    border-radius: 8px;\n}\n\n.header-toggle-button {\n    color: rgba(255, 255, 255, 0.7) !important;\n    border-color: rgba(255, 255, 255, 0.2) !important;\n    padding: 6px 16px !important;\n    text-transform: none !important;\n}\n\n.header-toggle-button.Mui-selected {\n    color: white !important;\n    background-color: rgba(255, 255, 255, 0.2) !important;\n}\n\n.header-toggle-button:hover {\n    background-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n.header-toggle-icon {\n    margin-right: 6px;\n    font-size: 20px;\n}\n\n.header-toggle-label {\n    font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
